<template>
  <div>
    <div class=" is-hidden-touch rental-location-summary locationSummary columns is-gapless">
        <div class="column is-narrow ">

            <div class="mb-2">
                <span class="is-block is-size-7 has-text-weight-bold">
                    {{ rentalEndpoint }}
                </span>

                <span class="is-size-7 has-text-grey">
                    {{ occursAt.date | formatDate }}
                </span>

                <span class="is-size-7 has-text-grey">
                    @
                </span>

                <span class="is-size-7 has-text-grey">
                    {{ occursAt.time | formatTime }}
                </span>

            </div>

            <div v-if="location.airportInfo" class="columns is-mobile is-gapless mb-1" >
                <div class="column is-narrow mr-3 has-text-centered">
                    <b-icon :icon="locationTypeIcon" custom-class="mt-3 has-text-grey "></b-icon>

                </div>
                <div class="column">
                    <span class="is-block has-text-weight-bold">{{ location.airportInfo.code}}</span>
                    <span class="is-block">{{ location.airportInfo.shuttle}}</span>
                    <a @click="goToDetails(location)"> Location Details </a>
                </div>
            </div>
            <div v-else class="columns is-gapless" style="margin-bottom: 5px;">
                <div class="column is-narrow mr-3 has-text-centered is-hidden-touch">
                    <b-icon :icon="locationTypeIcon" custom-class="mt-3 has-text-grey"></b-icon>

                </div>
                <div class="column">
                    <span class="is-block has-text-weight-bold">Non-Airport</span>
                    <span class="is-block">{{ location.address }}</span>
                    <a @click="goToDetails(location)"> Location Details </a>
                </div>
            </div>
<!--            <div v-if="mainPage">-->
<!--              <a  @click="selectLocation"> View results </a> with this {{locType}}-->
<!--            </div>-->

        </div>
    </div>
    <!-- MOBILE -->
    <div class="is-hidden-desktop rental-location-summary locationSummary columns is-gapless">
        <div class="column is-narrow">

            <div class="mb-2">
                <span class="is-block is-size-7 has-text-weight-bold">
                    {{ rentalEndpoint }}
                </span>

                <span class="is-size-7 has-text-grey">
                    {{ occursAt.date | formatDate }}
                </span>

                <span class="is-size-7 has-text-grey">
                    @
                </span>

                <span class="is-size-7 has-text-grey">
                    {{ occursAt.time | formatTime }}
                </span>

            </div>

            <div v-if="location.airportInfo" class="columns is-mobile is-gapless mb-1" >
                <div class="column is-narrow mr-3 has-text-centered is-hidden-touch">
                    <b-icon :icon="locationTypeIcon" custom-class="mt-3 has-text-grey"></b-icon>

                </div>
                <div class="column">
                    <span class="is-block has-text-weight-bold">{{ location.airportInfo.code}}</span>
                    <span class="is-block">{{ location.airportInfo.shuttle}}</span>
                    <a @click="goToDetails(location)"> Location Details </a>
                </div>
            </div>
            <div v-else class="columns is-gapless" style="margin-bottom: 5px;">
                <div class="column is-narrow mr-3 has-text-centered is-hidden-touch">
                    <b-icon :icon="locationTypeIcon" custom-class="mt-3 has-text-grey"></b-icon>

                </div>
                <div class="column">
                    <span class="is-block has-text-weight-bold">Non-Airport</span>
                    <span class="is-block">{{ location.address }}</span>
                    <a @click="goToDetails(location)"> Location Details </a>
                </div>
            </div>
            <div v-if="mainPage">
              <a  @click="selectLocation"> View results </a> <br /> with this {{locType}}
            </div>

        </div>
    </div>
  </div>
</template>

<script>
import CarDetails from './CarDetails.vue'

export default {
  components: {
  },
  data: function () {
    return {
        // rentalEndpoint: '',
    }
  },
  methods: {
    goToDetails(location) {
        var details = {
            parent: this,
            component: CarDetails,
            props: {
            "location": location
        },
            hasModalCard: true,
            trapFocus: true,
            width: 800
        }
        this.$buefy.modal.open(details)
    },
    selectLocation(){
      this.$emit('selected')

    },
  },
  props: {
      location: Object,
      occursAt: Object,
      rentalEndpoint: String,
      sameLocationAsPickup: Boolean,
      mainPage: Boolean
  },
  computed: {
      locationTypeIcon(){
          return this.location.airportInfo ? 'airplane' : 'map-marker'
      },
      locType(){
        return this.rentalEndpoint.toLowerCase()
      }
  }
}

</script>

<style lang="scss" scoped>
  // mobile
  @media screen and (max-width: 1023px) {
    .locationSummary {
      padding: 0 0 1em 0 !important;
      margin: 0 !important;
    }
    .car-location-container {
      border: 1px solid #eee;
      border-radius: 10px;
      padding: 0px;
    }

    .rental-location-summary {
        font-size: 12px;
    }
  }
  // pc
  @media screen and (min-width: 1024px) {
    .locationSummary{
      padding: 0.5rem !important;
      margin-right: 1.5rem !important;
      padding-left: 1rem !important;
    }

    .car-location-container {
      border: 1px solid #eee;
      border-radius: 10px;
      padding: 0px;
    }

    .rental-location-summary {
        border-left: 1px solid #ddd;
        font-size: 12px;
    }

  }
</style>
